import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDividerModule } from "@angular/material/divider";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { SharedModule } from "@shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { BreadcrumbsModalComponent } from "./breadcrumbs-modal.component";

@NgModule({
	declarations: [BreadcrumbsModalComponent],
	imports: [
		CommonModule,
		MatDividerModule,
		MatProgressSpinnerModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		MatFormFieldModule
	],
	exports: [BreadcrumbsModalComponent]
})
export class BreadcrumbsModalModule {}
